import {
	MOVE_TO_TOP,
	MOVE_UP,
	MOVE_DOWN,
	MOVE_TO_BOTTOM,
	AFTER,
	BEFORE,
	type MenuItemReorderOperation,
} from './constants.tsx';

export const menuItemReorderOperationToAction = (operation: MenuItemReorderOperation) => {
	switch (operation) {
		case MOVE_TO_TOP:
			return 'moveToTop';
		case MOVE_UP:
			return 'moveUp';
		case MOVE_DOWN:
			return 'moveDown';
		case MOVE_TO_BOTTOM:
			return 'moveToBottom';
		case AFTER:
			return 'dragged';
		case BEFORE:
			return 'dragged';
		default:
			return '';
	}
};
